import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
// RxJS
import { Subject } from 'rxjs';

import { SplashScreenService } from '../../../../../app/core/_base/layout';
import { AuthService } from '../../../../../app/core/auth/_services/auth.service';
import { AuthNoticeService } from '../../../../../app/core/auth/auth-notice/auth-notice.service';
import { environment } from '../../../../../environments';

@Component({
  selector: 'kt-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AuthCallbackComponent implements OnInit, OnDestroy {	
	loading = false;
	today: number = Date.now();
	private unsubscribe: Subject<any>;
	loginError: string;
	headerLogo: string;
	backgroundPage: string;

  constructor(
		private authNoticeService: AuthNoticeService,
		private _auth: AuthService,
		private splahScreenService: SplashScreenService
    ) { 
      this.unsubscribe = new Subject();
	  this.loading = true;
	  this.headerLogo = environment.assets.brandLogo;
	  this.backgroundPage = environment.assets.authCallbackBackground;
    }

	ngOnInit(): void {
		// this.authNoticeService.setNotice(`Iniciando sesion con: ${this._auth.getClaims().email}`); // use for clarification if needed
	  this._auth.completeAuthentication().then(()=>{
		this._auth.login()
		.subscribe(data => {  });
	  });  
	  
	}
  
	ngOnDestroy(): void {
		this.authNoticeService.setNotice(null);
		this.unsubscribe.next(void 0);
		this.unsubscribe.complete();
    	this.loading = false;
	}

	ngAfterViewInit(): void {		
		this.splahScreenService.hide();
	}

	getPageBackground() {
		return `url(${this.backgroundPage})`;
	}
}
